import { ViewportState, ViewportStateParams } from '../../states/ViewportState'

export class ViewportStateGPU extends ViewportState {

  public commitChanges(changes: ViewportStateParams) {
    //
  }
}
